import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './Modal.css';

export function ModalCloseIcon() {
  return (
    <svg className="modal-close-icon" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        d="M6 6l12 12M18 6L6 18"
      />
    </svg>
  );
}

function Modal({ isOpen, onClose, children, title, headerEnd = null, priority = 0, className = '' }) {
  const { t } = useTranslation('shared');
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="modal-backdrop" 
      onClick={handleBackdropClick}
      style={{ zIndex: 1000 + priority }}
    >
      <div className={`modal-content ${className}`} onClick={(e) => e.stopPropagation()}>
        {title && (
          <div className="modal-header">
            <div
              className={`modal-header-leading${headerEnd ? '' : ' modal-header-leading--solo'}`}
            >
              <h2>{title}</h2>
              {headerEnd}
            </div>
            <button type="button" className="modal-close" onClick={onClose} aria-label={t('common.close')}>
              <ModalCloseIcon />
            </button>
          </div>
        )}
        <div
          className={`modal-body ${
            className.includes('modal-content-wide') || className.includes('modal-content-discover-events-list')
              ? 'modal-body-no-padding'
              : ''
          }`}
        >
          {children}
        </div>
      </div>
    </div>
  );
}

export default Modal;








